"use client";

import { isMobile } from "@/utils/browser";
import { ImageBackground } from "@components/ui/custom/image-background";
import { useEffect, useState } from "react";

export function MarbleXBackground() {
  const [backdropClassName, setBackdropClassName] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    setBackdropClassName(
      isMobile() ? "backdrop-blur-sm bg-black/60" : "bg-black/60",
    );
  }, []);

  return (
    <ImageBackground
      staticImageUrl="/images/marblex-games/marble-x-bg.webp"
      backdropClassName={backdropClassName}
    />
  );
}
